import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
} from 'react';
import axios from 'axios';
import useInfiniteLoader from '../../../../../services/useInfiniteLoader';
import Notifications from '../../../../../services/notifications';
import NotificationListItem from './NotificationListItem';
import LoggedUserContext from '../../../../../contextProviders/LoggedUserContext';

const PAGE_SIZE = 50;
const fetchNotifications = async index => {
  const result = await axios.get('/api/user/me/notification/list', {
    headers: {
      'Accept-Version': '1.0.0',
      'X-Gamification-API': 'Games',
    },
    params: {
      populate: [
        'target',
        'rating',
        'game',
        'course',
        'event',
        'survey',
        'surveyContext',
        'score',
        'comment',
        'trophy',
        'trophy.trophyCustom',
        'accessSession',
        'chatGroup',
        'walletTransaction',
        'opportunity',
        'marketOrder',
      ],
      endDate: new Date().valueOf(),
      index,
      offset: PAGE_SIZE,
      sort: '-createdAt',
    },
  });

  return result.data;
};

const NotificationList = forwardRef((props, ref) => {
  const {
    data: notifications,
    loading,
    error,
    listRef,
    forceReload,
  } = useInfiniteLoader(fetchNotifications);
  const { loggedUser } = useContext(LoggedUserContext);
  useEffect(() => {
    if (error) {
      Notifications.showErrorFromRequest(error, 'notifications.failedToFetch');
    }
  }, [error]);

  useImperativeHandle(ref, () => ({
    forceReload: () => {
      forceReload();
    },
  }));

  return (
    <div className="notification-list" ref={listRef}>
      {notifications.map(notification => (
        <NotificationListItem
          key={notification._id}
          notification={notification}
          loggedUser={loggedUser}
        />
      ))}
      {loading && <div className="m-loader m-loader--dynamic m-loader--lg" />}
    </div>
  );
});

export default NotificationList;
